//@flow
/**
 * Learner reducer
 * @module learner/reducer
 */
import { Record, List } from 'immutable'
import { getProposedQuizId } from './lib'

export const UPDATE_LEARNER_NOTES = 'UPDATE_LEARNER_NOTES'
export const UPDATE_LEARNER_NOTES_REQUEST = 'UPDATE_LEARNER_NOTES_REQUEST'
export const UPDATE_LEARNER_NOTES_SUCCESS = 'UPDATE_LEARNER_NOTES_SUCCESS'
export const UPDATE_LEARNER_NOTES_FAILURE = 'UPDATE_LEARNER_NOTES_FAILURE'

export const SUBMIT_LEARNER_FORM_REQUEST = 'SUBMIT_LEARNER_FORM_REQUEST'
export const SUBMIT_LEARNER_FORM_PENDING = 'SUBMIT_LEARNER_FORM_PENDING'
export const SUBMIT_LEARNER_FORM_SUCCESS = 'SUBMIT_LEARNER_FORM_SUCCESS'
export const SUBMIT_LEARNER_FORM_FAILURE = 'SUBMIT_LEARNER_FORM_FAILURE'

export const SUBMIT_ANSWER_REQUEST = 'SUBMIT_ANSWER_REQUEST'
export const SUBMIT_ANSWER_PENDING = 'SUBMIT_ANSWER_PENDING'
export const SUBMIT_ANSWER_SUCCESS = 'SUBMIT_ANSWER_SUCCESS'
export const SUBMIT_ANSWER_FAILURE = 'SUBMIT_ANSWER_FAILURE'

export const FINISH_QUIZ_LATER_REQUEST = 'FINISH_QUIZ_LATER_REQUEST'
export const FINISH_QUIZ_LATER_SUCCESS = 'FINISH_QUIZ_LATER_SUCCESS'
export const FINISH_QUIZ_LATER_FAILURE = 'FINISH_QUIZ_LATER_FAILURE'

export const RESTORE_LEARNER_REQUEST = 'RESTORE_LEARNER_REQUEST'
export const RESTORE_LEARNER_SUCCESS = 'RESTORE_LEARNER_SUCCESS'
export const RESTORE_LEARNER_FAILURE = 'RESTORE_LEARNER_FAILURE'

export const UPDATE_DLRQ_LEARNER = 'UPDATE_DLRQ_LEARNER'
export const UPDATE_DLRQ_LEARNER_SUCCESS = 'UPDATE_DLRQ_LEARNER_SUCCESS'
export const UPDATE_DLRQ_LEARNER_FAILURE = 'UPDATE_DLRQ_LEARNER_FAILURE'

export const COMPLETE_DLRQ_LEARNER = 'COMPLETE_DLRQ_LEARNER'
export const COMPLETE_DLRQ_LEARNER_SUCCESS = 'COMPLETE_DLRQ_LEARNER_SUCCESS'
export const COMPLETE_DLRQ_LEARNER_FAILURE = 'COMPLETE_DLRQ_LEARNER_FAILURE'

export const CONFIRM_DP_RESET_REQUEST = 'CONFIRM_DP_RESET_REQUEST'
export const CONFIRM_DP_RESET_SUCCESS = 'CONFIRM_DP_RESET_SUCCESS'
export const CONFIRM_DP_RESET_FAILURE = 'CONFIRM_DP_RESET_FAILURE'

// Digital Proficiency
export const UPDATE_DP_LEARNER = 'UPDATE_DP_LEARNER'
export const COMPLETE_DP_LEARNER_SUCCESS = 'COMPLETE_DP_LEARNER_SUCCESS'
export const COMPLETE_DP_PRESCREENING_SUCCESS = 'COMPLETE_DP_PRESCREENING_SUCCESS'
export const DP_PREVIOUS_QUESTION = 'DP_PREVIOUS_QUESTION'

export const TOGGLE_EDIT_FORM = 'TOGGLE_EDIT_FORM'
// export const DP_SET_CATEGORY = 'DP_SET_CATEGORY'

export const UPDATE_QUESTION_ID = 'UPDATE_QUESTION_ID';

export type Action =
  | { type: 'UPDATE_LEARNER_NOTES', payload: string }
  | { type: 'UPDATE_LEARNER_NOTES_REQUEST' }
  | { type: 'UPDATE_LEARNER_NOTES_SUCCESS', payload: string }
  | { type: 'UPDATE_LEARNER_NOTES_FAILURE', payload: Error, error: true }
  | { type: 'SUBMIT_LEARNER_FORM_REQUEST' }
  | { type: 'SUBMIT_LEARNER_FORM_PENDING', payload: LearnerDetailsSubmission }
  | { type: 'SUBMIT_LEARNER_FORM_SUCCESS', payload: Learner }
  | { type: 'SUBMIT_LEARNER_FORM_FAILURE', payload: Error, error: true }
  | { type: 'SUBMIT_ANSWER_REQUEST' }
  | { type: 'SUBMIT_ANSWER_PENDING', payload: QuestionSubmission }
  | {
      type: 'SUBMIT_ANSWER_SUCCESS',
      payload: {
        response?: { nextQuestionId: string },
        questionSubmission: QuestionSubmission
      }
    }
  | { type: 'SUBMIT_ANSWER_FAILURE', payload: Error, error: true }
  | { type: 'FINISH_QUIZ_LATER_REQUEST' }
  | { type: 'FINISH_QUIZ_LATER_SUCCESS' }
  | { type: 'FINISH_QUIZ_LATER_FAILURE', payload: Error, error: true }
  | { type: 'RESTORE_LEARNER_REQUEST' }
  | { type: 'RESTORE_LEARNER_SUCCESS', payload: Learner | false }
  | { type: 'RESTORE_LEARNER_FAILURE', payload: Error, error: true }
  | { type: 'CONFIRM_DP_RESET_REQUEST' }
  | { type: 'CONFIRM_DP_RESET_SUCCESS', payload: Learner | false }
  | { type: 'CONFIRM_DP_RESET_FAILURE', payload: Error, error: true }
  | { type: 'PENDING_QUESTION_SUBMISSIONS_SCHEDULE', payload: Object }
  | { type: 'PENDING_QUESTION_SUBMISSIONS_SUBMITTING' }
  | { type: 'PENDING_QUESTION_SUBMISSIONS_CLEAR' }
  | { type: 'PENDING_QUESTION_SUBMISSIONS_CLEAR_SUCCESS' }
  | { type: 'UPDATE_DLRQ_LEARNER' }
  | { type: 'UPDATE_DP_LEARNER' }
  | { type: 'COMPLETE_DLRQ_LEARNER'}
  | { type: 'TOGGLE_EDIT_FORM'}
  | { type: 'UPDATE_QUESTION_ID'}

export const LearnerRecord = Record({
  pendingFormSubmission: null,
  pendingQuestionSubmissions: List(),
  submittingAnswer: false,
  loading: false,
  formCompeted: false,
  id: '',
  invite: '',
  notes: '',
  currentQuestionId: '',
  testLevel: getProposedQuizId(),
  email: '',
  learnerId: '',
  job: null,
  course: null,
  courseAligned: false,
  selectedCourseProfile: null,
  name: {
    first: '',
    last: ''
  },
  details: List(),
  answers: List(),
  complete: false,
  dlrqScore: {
    capability: 0,
    access: 0,
    baseline: 0,
    accessBaseline: 0,
    focusAreaBaseline: 0,
    focusAreas: [0, 0, 0, 0, 0]
  },
  dlrqWorkings: {   // workings just for use during development to display workings on screen for Dave
    capability: [],
    access: [],
    focusAreas: [[], [], [], [], []]
  },
  dlrqResponses: List(),
  dpPrescreeningResponse: {}, // Digital Proficiency pre-screening learner response
  dpMainResponse: [], // DP Main Quiz learner response
  dpPrescreeningResult: {}, // DP Prescreening result
  prescreeningComplete: false, // DP Prescreening complete flag
  confirmDeclaration: false,
  learnerFormSubmittedAt: null,
  invitedBy: '',
  inviteType: '',
  selectedCourseIdComparison: null,
  selectedJobIdComparison: null,
  assessmentVersion: null,
  confirmReset: {
    submitting: false,
    status: 'pending', // pending, success or failed
  }
})

/**
 * handles storing and fetching of learner data
 * @memberof learner/reducer
 */
export default function LearnerReducer(
  state: LearnerRecord = new LearnerRecord(),
  action: Action
): LearnerRecord {
  switch (action.type) {
    case RESTORE_LEARNER_REQUEST: {
      return state.merge({
        loading: true
      })
    }
    case RESTORE_LEARNER_FAILURE: {
      return state.merge({
        loading: false
      })
    }
    case RESTORE_LEARNER_SUCCESS: {
      if (!action.payload) return state
      // if there are pending question submissions then don't modify the
      // currentQuestionId or answers array, as this may be out of sync with the server
      let mergeAnswers = true
      let mergeCurrentQuestionId = true
      if (state.pendingQuestionSubmissions.size > 0) {
        mergeAnswers = false
        mergeCurrentQuestionId = false
      }

      return mergeLearner({
        state,
        learner: action.payload,
        mergeAnswers,
        mergeCurrentQuestionId
      })
    }

    case SUBMIT_LEARNER_FORM_PENDING: {
      const { payload: learnerDetails } = action
      return state.merge({
        pendingFormSubmission: learnerDetails,
        formCompeted: true,
        currentQuestionId: learnerDetails.initialQuestionRequest,
        testLevel: learnerDetails.quizId,
        courseAligned: learnerDetails.courseAligned === true,
        learnerId: learnerDetails.learnerId.value,
        name: {
          first: learnerDetails.firstname.value,
          last: learnerDetails.lastname.value
        },
        email: learnerDetails.email.value,
        learnerFormSubmittedAt: new Date(),
        details: learnerDetails.custom.map(({ _id, value, skipped }) => ({
          id: _id,
          value: skipped ? 'skipped' : value
        })),
        answers: [],
        prescreeningComplete:
          learnerDetails.state && learnerDetails.state.prescreeningComplete === true,
        assessmentVersion: learnerDetails.assessmentVersion
      })
    }

    case SUBMIT_LEARNER_FORM_SUCCESS: {
      return mergeLearner({
        state,
        learner: action.payload,
        pendingFormSubmission: null,
        mergeAnswers: false,
        mergeCurrentQuestionId:
          action.payload.courseAligned === true ||
          action.payload.testLevel === 'dpcourse' ||
          action.payload.testLevel !== state.get('testLevel')
      })
    }

    case CONFIRM_DP_RESET_REQUEST: {
      return state.set(
        'confirmReset',
        {
          ...state.confirmReset,
          submitting: true
        }
      )
    }

    case CONFIRM_DP_RESET_SUCCESS: {
      const merged = mergeLearner({
        state,
        learner: action.payload,
        pendingFormSubmission: null,
        mergeAnswers: false,
      })

      const finalMerged = merged.set('confirmReset', {
        ...merged.confirmReset,
        status: 'success'
      })

      return finalMerged;
    }

    case CONFIRM_DP_RESET_FAILURE: {
      return state.set(
        'confirmReset',
        {
          ...state.confirmReset,
          submitting: false,
          status: 'failed'
        }
      )
    }

    case UPDATE_LEARNER_NOTES:
      return state.set('notes', action.payload)

    case SUBMIT_ANSWER_PENDING: {
      const questionSubmission = action.payload
      const { answer, nextQuestionRequest } = questionSubmission
      const answers = state
        .get('answers')
        .filter(({ questionId }) => answer.questionId !== questionId)
        .concat({
          questionId: answer.questionId,
          answer
        })
      return state
        .set('answers', answers)
        .update('pendingQuestionSubmissions', pendingQuestionSubmissions =>
          pendingQuestionSubmissions.concat(questionSubmission)
        )
        .set('currentQuestionId', nextQuestionRequest)
        .set('submittingAnswer', false)
    }

    case SUBMIT_ANSWER_SUCCESS: {
      const {
        questionSubmission: { answer }
      } = action.payload
      return state.update(
        'pendingQuestionSubmissions',
        pendingQuestionSubmissions =>
          pendingQuestionSubmissions.filter(
            ({ answer: { questionId } }) => answer.questionId !== questionId
          )
      )
    }

    case SUBMIT_ANSWER_FAILURE: {
      return state.set('submittingAnswer', false)
    }

    case UPDATE_DLRQ_LEARNER: {
      const { answer, nextQuestionId, dlrqScore, dlrqWorkings } = action.payload
      
      return state
        .set('currentQuestionId', nextQuestionId)
        .set('dlrqScore', dlrqScore)
        .set('dlrqWorkings', dlrqWorkings)
        .update('dlrqResponses', dlrqResponses => dlrqResponses.concat(answer))
    }

    case COMPLETE_DLRQ_LEARNER_SUCCESS: {
      return state
        .set('complete', true)
    }

    case UPDATE_DP_LEARNER: {
      const { answer, nextQuestionId, prescreeningComplete } = action.payload
      if (prescreeningComplete) {
        return state
        .set('currentQuestionId', nextQuestionId)
        .update('dpMainResponse', dpMainResponse => {
          const index = Object.keys(answer)[0]
          const question = Object.values(answer)[0]
          if (dpMainResponse.length === 0) {
            dpMainResponse = answer
          }
          
          if (typeof dpMainResponse[index] !== 'undefined') {
            dpMainResponse[index][Object.keys(question)[0]]  = Object.values(question)[0]
          }
          return dpMainResponse
        });
      }
      
      return state
        .set('currentQuestionId', nextQuestionId)
        .update('dpPrescreeningResponse', dpPrescreeningResponse => ({...dpPrescreeningResponse, ...answer}));
    }

    case UPDATE_QUESTION_ID: {
      const { currentQuestionId } = action.payload
      return state
        .set('currentQuestionId', currentQuestionId)
    }

    case COMPLETE_DP_LEARNER_SUCCESS: {
      const { dpPrescreeningScore } = action.payload
      
      return state
        .set('dpPrescreeningResult', dpPrescreeningScore)
        .set('complete', true)
    }

    case COMPLETE_DP_PRESCREENING_SUCCESS: {
      const { dpPrescreeningScore } = action.payload;
      
      // SAVE THE SCORE FOR PRE-SCREENING
      return state
        .set('prescreeningComplete', true)
        .set('dpPrescreeningResult', dpPrescreeningScore);
    }

    case DP_PREVIOUS_QUESTION: {
      const { questionId, prescreeningComplete } = action.payload;
      const stateName = prescreeningComplete ? 'dpMainResponse': 'dpPrescreeningResponse'

      return state
        .set('currentQuestionId', questionId)
        .set('prescreeningComplete', prescreeningComplete)
        .update(`${stateName}`, data => {
          if (prescreeningComplete) {
            const category = Object.keys(data).pop()
            const categoryData = data[category]
            const answered = Object.keys(categoryData).length
            const qId = categoryData[Object.keys(categoryData).pop()].questionId
            if (answered > 1) {
              delete data[category][qId]
            } else {
              delete data[category]
            }
          } else {
            delete data[Object.keys(data).pop()]
          }
          return data
        })
    }

    case TOGGLE_EDIT_FORM: {
        return state.set('formCompeted', false)
    }


    default: {
      return state
    }
  }
}

/**
 * Merges a learner into the provided state.
 * @memberof learner/reducer
 */
function mergeLearner({
  state,
  learner: {
    _id,
    inviteCode,
    state: { currentQuestion, prescreeningComplete },
    testLevel,
    notes,
    learnerId,
    name,
    email,
    details,
    answers,
    complete,
    results,
    job,
    course,
    courseAligned,
    selectedCourseProfile,
    confirmDeclaration,
    learnerFormSubmittedAt,
    invitedBy,
    inviteType,
    selectedCourseIdComparison,
    selectedJobIdComparison,
    assessmentVersion,
    ...rest
  },
  clearPendingForm = false,
  mergeAnswers = true,
  mergeCurrentQuestionId = true
}: {
  state: LearnerRecord,
  learner: Learner,
  clearPendingForm?: boolean,
  mergeAnswers?: boolean,
  mergeCurrentQuestionId?: boolean
}) {
  const newState: {
    ...Learner,
    currentQuestionId?: string,
    answers?: Array<LearnerAnswer>,
    details: Array<{ id: string, value: string }>,
    pendingFormSubmission?: null | LearnerDetailsSubmission,
    prescreeningComplete: boolean,
    psResult: any,
    dpStateCategory: string,
    invitedBy?: string,
    selectedCourseIdComparison?: string,
    selectedJobIdComparison?: string,
    selectedCourseProfile?: Object,
    courseAligned?: boolean,
    learnerFormSubmittedAt?: string | Date,
  } = {
    loading: false,
    id: _id,
    invite: inviteCode,
    invitedBy,
    inviteType,
    selectedCourseIdComparison,
    selectedJobIdComparison,
    testLevel,
    notes,
    learnerId,
    name,
    email,
    complete,
    details: details.map(({ formElement: id, value }) => ({ id, value })),
    prescreeningComplete: prescreeningComplete,
    dpPrescreeningResult: null,
    dpPrescreeningResponse: null,
    job,
    course,
    courseAligned: courseAligned === true || testLevel === 'dpcourse',
    selectedCourseProfile,
    confirmDeclaration,
    learnerFormSubmittedAt,
    assessmentVersion
  }
  let dpPrescreeningResult = []
  let dpPrescreeningResponse = []
  if (results !== undefined && results.prescreening !== undefined) {
    dpPrescreeningResult = results.prescreening;
  }
  if (answers !== undefined && answers.prescreening !== undefined) {
    dpPrescreeningResponse = answers.prescreening
  }

  let dpMainResponse = []
  if (answers !== undefined && answers.main !== undefined) {
    dpMainResponse = answers.main;
  }
  if (clearPendingForm) {
    newState.pendingFormSubmission = null
  }
  if (mergeCurrentQuestionId) {
    newState.currentQuestionId = currentQuestion
  }
  
  return state
    .merge(newState)
    .set('dpPrescreeningResult', dpPrescreeningResult)
    .set('dpPrescreeningResponse', dpPrescreeningResponse)
    .set('dpMainResponse', dpMainResponse)
}



// WEBPACK FOOTER //
// ./src/state/learner/reducer.js